var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["state", "onFormChange", "field", "onMaximize"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { CallOutlined, Circle } from '@mui/icons-material';
import { Button, capitalize, Card, Chip, Dialog, Divider, IconButton, Stack, Typography } from '@mui/material';
import { GridActionsCellItem, gridClasses, GridToolbarContainer, GridToolbarQuickFilter, useGridApiContext } from '@mui/x-data-grid-premium';
import dayjs from 'dayjs';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Maximize } from '../../../../builderPackage/assets/svg';
import { DynamicCatalogBuilder } from '../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { FormSingleSelect } from '../../../../builderPackage/components/dynamicFormBuilder/components/formSingleSelect';
import { LOCAL_STORAGE_KEYS } from '../../../../constants';
import { setReducerState } from '../../../../redux/crudSlice';
import { useAppDispatch } from '../../../../store/hooks';
import { info, secondary } from '../../../../theme/colors';
import { getLocalStorageItem } from '../../../../utils/storageHelper';
import { crmCustomerVehiclePaging, CRMKeys } from '../services/apiCalls';
import { showSurface } from '../../../../redux/awaitedSurfacesSlice';
import CrmCustomerProfile from '../crmCustomerProfile';
import { ServiceDetailsFilters } from '../services/entity';
import CreateAppointment from '../../../appointmentV3/pages/createAppointment';
import CircularProgressWithLabel from './circularProgressWithLabel';
import CommunicationTemplateForm from './communicationDialog';
export default function ServiceDueDetails(props) {
    var _a;
    var _this = this;
    var _getLocalStorageItem;
    var value = props.value, onChange = props.onChange;
    var dispatch = useAppDispatch();
    var branch = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.Branches[0];
    var navigate = useNavigate();
    var _b = useState(), maximize = _b[0], setMaximize = _b[1];
    useEffect(function () {
        if ((value === null || value === void 0 ? void 0 : value.PagingRequest) !== undefined)
            dispatch(setReducerState({
                key: "".concat(CRMKeys.paging, "Updated"),
                value: true
            }));
    }, [value === null || value === void 0 ? void 0 : value.PagingRequest]);
    var onMaximize = function () {
        setMaximize(function (prev) { return !prev; });
    };
    // details table
    var detailColumns = [{
            field: 'Customer',
            headerName: 'Customer',
            flex: 1,
            minWidth: 400,
            valueFormatter: function (value, row) { return "".concat(value === null || value === void 0 ? void 0 : value.FirstName, " ").concat(value === null || value === void 0 ? void 0 : value.LastName, " ").concat(value === null || value === void 0 ? void 0 : value.Code, " ").concat(row === null || row === void 0 ? void 0 : row.RegistrationNo, " ").concat(row === null || row === void 0 ? void 0 : row.ProductName); },
            renderCell: function (_ref) {
                var _row$Customer, _row$Customer2, _row$Customer3, _row$Customer4;
                var row = _ref.row;
                return /*#__PURE__*/ React.createElement(Stack, {
                    height: "100%",
                    direction: "column",
                    justifyContent: "center"
                }, /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                    textTransform: "capitalize"
                }, row === null || row === void 0 || (_row$Customer = row.Customer) === null || _row$Customer === void 0 || (_row$Customer = _row$Customer.FirstName) === null || _row$Customer === void 0 ? void 0 : _row$Customer.toLowerCase(), " ", row === null || row === void 0 || (_row$Customer2 = row.Customer) === null || _row$Customer2 === void 0 || (_row$Customer2 = _row$Customer2.LastName) === null || _row$Customer2 === void 0 ? void 0 : _row$Customer2.toLowerCase(), /*#__PURE__*/ React.createElement(Circle, {
                    color: "secondary",
                    sx: {
                        height: 5,
                        width: 5
                    }
                }), /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit",
                    color: "text.secondary"
                }, "(", row === null || row === void 0 || (_row$Customer3 = row.Customer) === null || _row$Customer3 === void 0 ? void 0 : _row$Customer3.Code, ")"), /*#__PURE__*/ React.createElement(Circle, {
                    color: "secondary",
                    sx: {
                        height: 5,
                        width: 5
                    }
                }), /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit",
                    color: "text.tertiary"
                }, row === null || row === void 0 || (_row$Customer4 = row.Customer) === null || _row$Customer4 === void 0 ? void 0 : _row$Customer4.MobileNumber)), /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit"
                }, row === null || row === void 0 ? void 0 : row.RegistrationNo, " - ", /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit",
                    color: "secondary",
                    display: "inline-block"
                }, row === null || row === void 0 ? void 0 : row.ProductName)));
            }
        }, {
            field: 'CrossSellOpportunities',
            headerName: 'Cross sell opportunities',
            flex: 1,
            minWidth: 150,
            valueFormatter: function (value) { return Object.keys(value !== null && value !== void 0 ? value : {}).filter(function (it) { return Boolean(value[it]); }).join(' '); },
            renderCell: function (_ref2) {
                var _Object$entries;
                var value = _ref2.value;
                return /*#__PURE__*/ React.createElement(Stack, {
                    height: "100%",
                    direction: "row",
                    alignItems: "center",
                    gap: 0.5
                }, (_Object$entries = Object.entries(value)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.map(function (_ref3) {
                    var key = _ref3[0], val = _ref3[1];
                    return val ? /*#__PURE__*/ React.createElement(Chip, {
                        variant: "outlined",
                        size: "small",
                        label: key,
                        color: "info",
                        sx: {
                            background: info[50],
                            borderRadius: 1.5
                        }
                    }) : null;
                }));
            }
        }, {
            field: 'ServiceDrop',
            headerName: 'Service drop probability',
            flex: 1,
            minWidth: 100,
            valueFormatter: function (value, row) {
                var _row$Customer5;
                return (row === null || row === void 0 || (_row$Customer5 = row.Customer) === null || _row$Customer5 === void 0 ? void 0 : _row$Customer5.ServiceDropProbability) + ' risk';
            }
        }, {
            field: 'NextServiceTypeName',
            headerName: 'Due service type',
            minWidth: 120,
            flex: 1
        }, {
            field: 'CallDetails',
            headerName: 'Call Details',
            width: 100,
            valueFormatter: function (value) { return value === 0 ? 'Fresh call' : 'Follow up'; },
            renderCell: function (_ref4) {
                var value = _ref4.value, formattedValue = _ref4.formattedValue;
                return /*#__PURE__*/ React.createElement(Stack, {
                    height: "100%",
                    direction: "column",
                    justifyContent: "center"
                }, /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit"
                }, formattedValue), /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit",
                    color: "secondary",
                    display: "inline-block"
                }, value, " attempt"));
            }
        }, {
            field: 'NextServiceDueDate',
            headerName: 'Next service date',
            width: 120,
            valueFormatter: function (val) { return dayjs(val).format('DD MMM, YYYY'); }
        }, {
            type: 'actions',
            field: 'actions',
            width: 100,
            getActions: function (_ref5) {
                var row = _ref5.row;
                return [/*#__PURE__*/ React.createElement(GridActionsCellItem, {
                        component: Button,
                        sx: {
                            p: 1,
                            minWidth: 'auto'
                        },
                        label: "Call",
                        icon: /*#__PURE__*/ React.createElement(CallOutlined, {
                            color: "info",
                            fontSize: "small"
                        }),
                        onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            var _row$Customer6, _row$Customer7, _row$Customer8, _row$Customer9, callResponse;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Dialog',
                                            Component: CommunicationTemplateForm,
                                            componentProps: {
                                                request: {
                                                    ChannelType: 'Call',
                                                    CustomerId: row === null || row === void 0 ? void 0 : row.CustomerId,
                                                    CommunicationDate: dayjs().toISOString(),
                                                    OrganizationId: branch === null || branch === void 0 ? void 0 : branch.OrganizationId,
                                                    ParentOrganizationId: branch === null || branch === void 0 ? void 0 : branch.ParentOrganizationId,
                                                    Email: row === null || row === void 0 || (_row$Customer6 = row.Customer) === null || _row$Customer6 === void 0 ? void 0 : _row$Customer6.Email,
                                                    MobileNumber: row === null || row === void 0 || (_row$Customer7 = row.Customer) === null || _row$Customer7 === void 0 ? void 0 : _row$Customer7.MobileNumber,
                                                    Name: "".concat(capitalize(row === null || row === void 0 || (_row$Customer8 = row.Customer) === null || _row$Customer8 === void 0 || (_row$Customer8 = _row$Customer8.FirstName) === null || _row$Customer8 === void 0 ? void 0 : _row$Customer8.toLowerCase()), " ").concat(capitalize(row === null || row === void 0 || (_row$Customer9 = row.Customer) === null || _row$Customer9 === void 0 || (_row$Customer9 = _row$Customer9.LastName) === null || _row$Customer9 === void 0 ? void 0 : _row$Customer9.toLowerCase())),
                                                    VinNo: row === null || row === void 0 ? void 0 : row.Vin
                                                }
                                            },
                                            containerProps: {
                                                maxWidth: 'xs',
                                                fullWidth: true,
                                                disableEscapeKeyDown: true,
                                                onClose: function () { }
                                            }
                                        }))];
                                    case 1:
                                        callResponse = _a.sent();
                                        if (!((callResponse === null || callResponse === void 0 ? void 0 : callResponse.payload) !== 'cancel')) return [3 /*break*/, 3];
                                        return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                containerProps: {
                                                    open: true,
                                                    fullWidth: true,
                                                    maxWidth: 'xl'
                                                },
                                                Component: CrmCustomerProfile,
                                                componentProps: {
                                                    request: {
                                                        id: row === null || row === void 0 ? void 0 : row.CustomerId
                                                    }
                                                }
                                            }))];
                                    case 2:
                                        _a.sent();
                                        _a.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }
                    }), /*#__PURE__*/ React.createElement(GridActionsCellItem, {
                        label: "Schedule Appt.",
                        showInMenu: true,
                        divider: true,
                        onClick: function () {
                            dispatch(showSurface({
                                type: 'Dialog',
                                containerProps: {
                                    fullWidth: true,
                                    maxWidth: 'md'
                                },
                                Component: CreateAppointment,
                                componentProps: {
                                    view: 'telecaller',
                                    request: {
                                        Key: 'VinNo',
                                        Value: row === null || row === void 0 ? void 0 : row.Vin
                                    }
                                }
                            }));
                        }
                    }), /*#__PURE__*/ React.createElement(GridActionsCellItem, {
                        label: "View customer 360",
                        showInMenu: true,
                        onClick: function () { return navigate("/crm/".concat(row === null || row === void 0 ? void 0 : row.CustomerId, "?mode=edit")); }
                    })];
            }
        }];
    var Container = useCallback(function (_ref6) {
        var children = _ref6.children;
        if (maximize) {
            return /*#__PURE__*/ React.createElement(Dialog, {
                open: true,
                fullWidth: true,
                maxWidth: "xl",
                onClose: function () {
                    setMaximize(false);
                },
                PaperProps: {
                    sx: {
                        p: 2
                    }
                }
            }, children);
        }
        else {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
        }
    }, [maximize]);
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: detailColumns,
        dataGridProps: {
            hideFooter: true,
            // disableColumnMenu: true,
            disableColumnSorting: true,
            initialState: {
                density: 'standard',
                pinnedColumns: {
                    right: ['actions']
                }
            },
            cellSelection: false,
            filterMode: 'client',
            disableRowGrouping: true,
            slots: {
                toolbar: ServiceReminderToolbar,
                quickFilterIcon: function () { return null; }
            },
            slotProps: {
                toolbar: {
                    onFormChange: onChange,
                    state: value,
                    onMaximize: onMaximize
                }
            },
            sx: maximize ? (_a = {},
                _a["& .".concat(gridClasses.virtualScroller)] = {
                    minHeight: 150
                },
                _a) : undefined
        },
        getPagingData: crmCustomerVehiclePaging,
        pagingAPIKey: CRMKeys.paging,
        pagingAPIRequest: _objectSpread({
            // OrganizationId: branchId,
            OrganizationId: "5e75d742-c9a5-429e-b825-a80e21208d36"
        }, value === null || value === void 0 ? void 0 : value.PagingRequest)
    }));
}
export var ServiceReminderToolbar = function (props) {
    var _a = props.state, state = _a === void 0 ? {} : _a, onFormChange = props.onFormChange, field = props.field, onMaximize = props.onMaximize, others = _objectWithoutProperties(props, _excluded);
    var gridApi = useGridApiContext();
    var onFilterChange = function (filters) {
        gridApi.current.setQuickFilterValues(filters);
    };
    return /*#__PURE__*/ React.createElement(GridToolbarContainer, _extends({}, others, {
        sx: {
            p: 1.5,
            gap: 1.5,
            borderBottom: '1px solid ' + secondary[200],
            justifyContent: 'end'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "lg",
        fontWeight: "strong",
        flexGrow: 1
    }, "Service due calls", /*#__PURE__*/ React.createElement(Chip, {
        label: '15 calls',
        color: "info",
        size: "small",
        variant: "outlined",
        sx: {
            mx: 1,
            background: info[50],
            fontWeight: 'medium',
            fontSize: 'sm'
        }
    })), /*#__PURE__*/ React.createElement(Card, {
        component: Stack,
        variant: "outlined",
        direction: "row",
        p: 1,
        gap: 1
    }, /*#__PURE__*/ React.createElement(CircularProgressWithLabel, {
        title: "Calls done",
        count: 79,
        total: 100,
        value: Math.round(79 / 100 * 100)
    }), /*#__PURE__*/ React.createElement(Divider, {
        orientation: "vertical",
        variant: "fullWidth",
        flexItem: true,
        sx: {
            borderStyle: 'dashed',
            borderSpacing: 8
        }
    }), /*#__PURE__*/ React.createElement(CircularProgressWithLabel, {
        title: "Appt. scheduled",
        count: 45,
        total: 79,
        value: Math.round(45 / 79 * 100)
    })), (state === null || state === void 0 ? void 0 : state.PagingRequest) && /*#__PURE__*/ React.createElement(Button, {
        id: "clear",
        color: "secondary",
        onClick: function (e) {
            onFormChange === null || onFormChange === void 0 || onFormChange(e, null);
        }
    }, "Clear filters"), /*#__PURE__*/ React.createElement(FormSingleSelect, {
        fullWidth: false,
        size: "small",
        valueExpr: "Name",
        placeholder: "All",
        options: ServiceDetailsFilters,
        MenuProps: {
            anchorOrigin: {
                horizontal: 'right',
                vertical: 'bottom'
            },
            transformOrigin: {
                horizontal: 'right',
                vertical: 'top'
            }
        },
        onChange: function (e, item) {
            var _item$filters;
            return onFilterChange((_item$filters = item === null || item === void 0 ? void 0 : item.filters) !== null && _item$filters !== void 0 ? _item$filters : []);
        }
    }), /*#__PURE__*/ React.createElement(GridToolbarQuickFilter, {
        variant: "outlined",
        size: "small",
        sx: {
            p: 0
        },
        debounceMs: 500
    }), /*#__PURE__*/ React.createElement(IconButton, {
        id: "maximize",
        size: "medium",
        color: "secondary",
        onClick: onMaximize
    }, /*#__PURE__*/ React.createElement(Maximize, {
        fontSize: "small"
    })));
};
